module.exports = __webpack_public_path__ + "img/discord-icon-hover.56b57121.png";